<div class="my-3">
  <div class="position-relative mr-2 mb-2 {{ !mobToggle && 'w-300px' }}">
    <input
      type="text"
      [(ngModel)]="history_keyword"
      [ngModelOptions]="{ standalone: true }"
      id="keywordInput"
      (input)="searchHistory()"
      name="task-search"
      class="_input-icon"
      placeholder="Search"
      (keydown.enter)="$event.preventDefault()" />
    <i class="pi pi-search _search-icon"></i>
    <i class="pi pi-times _cross-icon" *ngIf="history_keyword" (click)="history_keyword = ''; searchHistory()"></i>
  </div>
</div>
<div class="history-body mt-3 {{ mobToggle ? 'w-240px' : 'w-100' }}">
  <div class="position-relative">
    <div class="scroll_landing_page" (scroll)="onScroll($event)" #scrollableElement>
      <i class="pi pi-arrow-up" (click)="scrollToTop()" *ngIf="scrollTop > 50"></i>
      <p-table
        id="propertycolumns"
        [autoLayout]="true"
        [paginator]="false"
        [rows]="rows"
        [value]="historyList"
        dataKey="_id"
        [rowHover]="false"
        [tableStyle]="{ 'min-width': '45rem' }">
        <ng-template pTemplate="header" let-columns>
          <tr class="no-wrap">
            <th class="pl-0 w-150px">Changed Date</th>
            <th class="pl-0">Changed By</th>
            <th class="pl-0">Event</th>
            <th class="pl-0">Changed Field</th>
            <th class="pl-0">Old Value</th>
            <th class="pl-0">New Value</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-history let-columns="columns">
          <ng-container>
            <tr [ngClass]="{ 'ai-correction-row': history?.event === 'AI Correction' }">
              <td class="py-2 px-0">
                {{ isDate(history?.created_at) ? (history?.created_at | date: 'dd-MM-YYYY hh:mm a') : history?.created_at }}
              </td>
              <td class="py-2 px-0">
                {{ history?.user_name }}
                <span *ngIf="history?.event === 'AI Correction'" class="ai-corrected-badge" pTooltip="Corrected by Remmi AI" tooltipPosition="top">
                  <i class="pi pi-sparkles"></i>
                </span>
              </td>
              <td class="py-2 px-0">{{ history?.fields?.field_name == 'Allocation' ? 'Removed' : history?.event }}</td>
              <td class="py-2 px-0">{{ history?.fields?.filed_name || showFieldName(history?.fields?.field_name) }}</td>
              <td class="py-2 px-0">
                <div *ngIf="history?.fields?.old_value">
                  <div>
                    <span
                      class="time-style"
                      (click)="toggleCollapse(history)"
                      [innerHTML]="getDisplayValue(history?.fields?.old_value, history.isOpen)">
                    </span>
                    <!-- <span
                      class="time-style"
                      (click)="toggleCollapse(history)"
                      [innerHTML]="
                        history.isOpen
                          ? history?.fields?.old_value == 'retail'
                            ? 'Retail'
                            : (history?.fields?.old_value | slice: 0 : 20)
                          : history?.fields?.old_value == 'retail'
                            ? 'Retail'
                            : history?.fields?.old_value
                      ">
                    </span> -->
                  </div>
                </div>
              </td>
              <td class="py-2 px-0">
                <div *ngIf="history?.fields?.new_value">
                  <ng-container *ngIf="history?.fields?.filed_name === 'Reaxmlfeed'; else noHTMLFormat">
                    <span class="time-style" (click)="toggleCollapse(history)"
                      >{{ history.isOpen ? (history?.fields?.new_value | slice: 0 : 25) : history?.fields?.new_value }}
                    </span>
                  </ng-container>
                  <ng-template #noHTMLFormat>
                    <span
                      class="time-style"
                      (click)="toggleCollapse(history)"
                      [innerHTML]="
                        history.isOpen
                          ? history?.fields?.new_value == 'retail'
                            ? 'Retail'
                            : history?.fields?.new_value?.toString()?.slice(0, 25)
                          : history?.fields?.new_value == 'retail'
                            ? 'Retail'
                            : history?.fields?.new_value
                      ">
                    </span>
                  </ng-template>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="!pageLoad && historyList?.length === 0">
            <td colspan="5">No record found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="pageLoad">
            <td colspan="5">
              <div class="loading skeleton-header">
                <p class="ml-3">Loading records...</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="mt-4">
    <p *ngIf="historyList?.length > 0">
      {{ 'Records: ' + totalRecord }}
    </p>
  </div>
</div>
